import { produce } from "immer";
import type { Error, ErrorAction } from "../types";
import { ERROR_SAVE, CLEAR_ERROR } from "../constants/actionTypes";

const initialState: Error = {
  message: "",
  errors: [],
};

export default produce((draft: Error, action: ErrorAction): Error => {
  switch (action.type) {
    case CLEAR_ERROR:
      return initialState;
    case ERROR_SAVE:
      return action.payload;
    default:
      return draft;
  }
}, initialState);
